<template>
	<span class="w-20 h-20 rounded inline-flex items-center justify-center text-white flex-none" :class="bgColor">
		{{ letter }}
	</span>
</template>

<script>
export default {
	name: 'WorkspaceAvatar',
	props: {
		colorClass: {type: String, default: null},
		name: {type: String, required: true},
	},
	computed: {
		bgColor() {
			const colors = ['bg-red-500', 'bg-green-500', 'bg-blue-500', 'bg-yellow-500']
			return this.colorClass || colors[Math.floor(Math.random() * colors.length)]
		},
		letter() {
			return this.name[0]?.toUpperCase() || ''
		},
	},
}
</script>
